export enum WorkDurationState
{
    Unspecified = 0,
    Working = 10,
    Pause = 20,
}